<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Client Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="sm" variant="success" @click="showUploadModal = true"
                ><i class="fa fa-upload mr-1"></i>Upload Sales Person-Client Map</b-button
              >
              <b-button size="sm" variant="info" @click="goToClientDashboard"
                >Client TEUS Dashboard</b-button
              >
              <b-button size="sm" variant="warning" @click="goToMain"
                >New Client</b-button
              >
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReportsAss('All_CLIENT_Report')"
                variant="outline-info"
                >Export as Excel</b-button
              > -->
              <b-button
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                class="ml-3"
                @click="getReportsAss('All_CLIENT_Report', 'Export as Excel')"
                size="sm"
                variant="outline-info"
                >{{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <b-button
                :disabled="ExcelBtnName1 != 'New Export as Excel' ? true : false"
                class="ml-3"
                @click="getReportsNew('All_CLIENT_ReportNew', 'New Export as Excel')"
                size="sm"
                variant="outline-info"
                >{{ ExcelBtnName1 }}
                <b-spinner
                  v-if="ExcelBtnName1 != 'New Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small>{{ totalRows }} Entries</small>
          </h5>
        </div>
        <div>
          <b-row>
            <b-col md="6">
              <label for="clientId"></label>
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    :formatter="capitalizeAll"
                    @input="debounceSearch"
                    v-model="FilterData.CommonFilter"
                    placeholder="Type To Search"
                  />
                  <b-input-group-append>
                    <b-button :disabled="!FilterData.CommonFilter" @click="Clearfilter()"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2" class="mb-1"
              ><label for="clientId">Type Of Client </label>
              <model-list-select
                :list="clientTypesLabelsList"
                id="clientNamenew"
                v-model="FilterData.ClientTypeFilter"
                option-value="clientTypeVal"
                option-text="clientTypeText"
                placeholder="Type Of Client"
                @input="debounceSearch"
              ></model-list-select
            ></b-col>
            <b-col md="2" class="mb-1"
              ><label for="clientId">Client Type</label>
              <model-list-select
                :list="clientTypeList"
                id="clientNamenew"
                v-model="FilterData.ClientType"
                option-value="val"
                option-text="type"
                placeholder="Client Type"
                @input="debounceSearch"
              ></model-list-select
            ></b-col>
            <b-col md="2" v-if="
            $sessionsStorage.get('nameUser') == 'Bhavneesh' ||
            $sessionsStorage.get('cust_username') == 'admin'
          ">
          <label for="clientId">Status</label>
            <model-list-select :list="StatusTypeList" v-model="Status" option-value="StatusTypeVal"
              option-text="StatusTypeTxt" placeholder="Select Status" @input="viewClientDetail"></model-list-select>
          </b-col>
            <b-col md="8">
              <input
                type="checkbox"
                @click="SelectAll(clientListView)"
                v-model="isCheckAll"
              />

              <label>Select / Deselect All Count({{ this.AllClientIds.length }})</label>
              <Send-Email
                v-if="AllClientIds.length > 0"
                :AgentId="AllClientIds"
                :AllEmailId="AllEmailId"
                :type="
                  FilterData.ClientType ? FilterData.ClientType + ' Client' : 'Client'
                "
              ></Send-Email>
            </b-col>
          </b-row>
        </div>
        <div class="table-responsive tableMain">
          <b-table
            show-empty
            stacked="md"
            :items="clientListView"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="clientId" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              <input
                type="checkbox"
                v-bind:value="row0.item.clientId"
                v-bind:id="row0.item.email"
                v-model="AllClientIds"
                @change="updateSelectAll($event, row0.item)"
              />
            </template>
            <template slot="clientName" slot-scope="row11">
              <div
                :style="row11.item.isKYC != 'Yes' ? 'color:red' : ''"
                @click="viewClientpage(row11.item)"
                class="showMoreData"
              >
                <span>{{ row11.item.clientName }}</span><br />
                <span>Client Type : {{ row11.item.clientType }}</span>
                <br />
                <span>Created By : {{ row11.item.CreatedBy }}</span>
                <br />
                <span>Created At : {{ row11.item.CreatedDate }}</span>
                <br />
                <h6>
                  <b-badge v-if="row11.item.isKYC != 'Yes'" variant="danger"
                    >Kyc Not Done</b-badge
                  >
                </h6>
              </div>
            </template>
            <template slot="is_lead" slot-scope="row2">
              <model-list-select
                v-if="
                  $sessionsStorage.get('nameUser') == 'Bhavneesh' ||
                  $sessionsStorage.get('cust_username') == 'admin'
                "
                :list="clientTypeTableList"
                id="clientNamenew"
                v-model="row2.item.is_lead"
                option-value="val"
                option-text="type"
                placeholder="Client Type"
                @input="updateClientType(row2.item)"
              ></model-list-select>
              <h6>
                <b-badge
                  :variant="
                    row2.item.is_lead == 2
                      ? 'primary'
                      : row2.item.is_lead == 3
                      ? 'warning'
                      : row2.item.is_lead == 4
                      ? 'secondary'
                      : 'success'
                  "
                  >{{
                    row2.item.is_lead == 2
                      ? "Lead Client"
                      : row2.item.is_lead == 3
                      ? "Prerequisite Client"
                      : row2.item.is_lead == 4
                      ? "KYC Template Client"
                      : "Direct KYC Client"
                  }}</b-badge
                >
              </h6>
            </template>
            <template slot="phoneKYC" slot-scope="row1">
              <span>Contact No. : {{ row1.item.phoneKYC }}</span>
              <br />
              <span>Email-Address : {{ row1.item.email }}</span>
              <br />
              <span>Alternate Email-Addr : {{ row1.item.altMail }}</span>
              <br />
              <span>
                Corporate Address : {{ row1.item.corporateAddress }}
                <br />
                {{ row1.item.stateName }}
              </span>
            </template>
            <template slot="enq_no" slot-scope="row4">
              <span>Enq No. : {{ row4.item.enq_no }}</span>
              <br />
              <span>Container Det. : {{ row4.item.containerDetails }}</span>
            </template>
            <template slot="clientId" slot-scope="row2">
              <div v-if="adminToggle == 'Admin'" :id="'row' + row2.item.clientId">
                <md-switch
                  :id="'approval' + row2.item.clientId"
                  name="approval"
                  class="md-primary"
                  :value="row2.item.clientIsActive == 1 ? true : false"
                  @change="activateUser(row2.item)"
                >
                  <h6>
                    <br />
                    <b-badge style="margin-left: -45px">{{
                      row2.item.clientIsActive == 1 ? "Active" : "In-Active"
                    }}</b-badge>
                  </h6>
                </md-switch>
              </div>
              <div v-else :id="'row' + row2.item.clientId">
                <h6>
                  <b-badge>{{
                    row2.item.clientIsActive == 1 ? "Active" : "In-Active"
                  }}</b-badge>
                </h6>
              </div>
            </template>
            <template slot="clientIsActive" slot-scope="row3">
              <b-button
                style="font-size: 0.675rem"
                size="sm"
                variant="primary"
                @click="goToDrag(row3.item)"
                >Clients Excell Temp</b-button
              >
              <b-button
                v-if="
                  $sessionsStorage.get('nameUser') == 'Bhavneesh' ||
                  $sessionsStorage.get('cust_username') == 'admin'
                "
                style="font-size: 0.675rem"
                size="sm"
                variant="primary"
                @click="downloadZip(row3.item)"
                >Download Zip</b-button
              >
              <b-button
                variant="outline-danger"
                size="sm"
                @click="deleteClient(row3.item.clientId)"
              >
                <md-icon>delete_sweep</md-icon>
              </b-button>
            </template>
          </b-table>
        </div>

        <div>
          <b-pagination
            limit="5"
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>

    <!-- Sales Person-Client Upload Modal -->
    <b-modal
      id="sales-client-upload-modal"
      v-model="showUploadModal"
      title="Upload Sales Person - Client Mapping"
      size="xl"
      hide-footer
      @hidden="showUploadModal = false"
    >
      <SalesClientUpload @upload-success="handleUploadSuccess"></SalesClientUpload>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "vue2-datepicker";

import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import ClientUserService from "../../../services/ClientUserService";
import CommonService from "../../../services/CommonService";
import SendEmail from "../../common/sendEmail.vue";
import NodeLockPannelService from "../../../services/NodeLockPannelService.js";
import SalesClientUpload from "../../common/SalesClientUpload.vue";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      if (globalPermissionStatus("addClient") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("addClient")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.$store.dispatch("setCurrentRoute", "/client/viewClient");

      this.viewClientDetail();
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },

  data() {
    return {
      adminToggle: this.$sessionsStorage.get("designation"),
      isCheckAll: false,
      AllClientIds: [],
      AllEmailId: [],
      selectedAllClientIds: "",
      selectedEmailId: "",
      Status: "2",
      StatusTypeList: [
        {
          StatusTypeVal: "0",
          StatusTypeTxt: "In-Active",
        },
        {
          StatusTypeVal: "1",
          StatusTypeTxt: "Active",
        },
        {
          StatusTypeVal: "2",
          StatusTypeTxt: "All",
        },
      ],
      ClientType: "5",
      fields: [
        {
          key: "clientId",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "is_lead",
          label: "Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "phoneKYC",
          label: "Contact Detail",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "enq_no",
          label: "Container/Enq Detail",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientIsActive",
          label: "Delete",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
        },
      ],
      clientTypeList: [
        {
          type: "All",
          val: "5",
        },
        {
          type: "Direct KYC Client",
          val: "1",
        },
        {
          type: "Lead Client",
          val: "2",
        },
        {
          type: "Prerequisite Client",
          val: "3",
        },
        {
          type: "KYC Template",
          val: "4",
        },
      ],
      clientTypesLabelsList: [
        { clientTypeVal: null, clientTypeText: "Please Select Client Type" },
        {
          clientTypeVal: "Client",
          clientTypeText: "Client",
        },

        {
          clientTypeVal: "Overseas",
          clientTypeText: "Overseas",
        },
        {
          clientTypeVal: "Lead",
          clientTypeText: "Lead",
        },
        {
          clientTypeVal: "Transporter",
          clientTypeText: "Transporter",
        },
        {
          clientTypeVal: "Trader",
          clientTypeText: "Trader",
        },
        {
          clientTypeVal: "Freight_Forwarder",
          clientTypeText: "Freight Forwarder",
        },
         {
          clientTypeVal: "Consignee",
          clientTypeText: "Consignee",
        },
      ],
      clientTypeTableList: [
        {
          type: "Direct KYC Client",
          val: "1",
        },
        {
          type: "Lead Client",
          val: "2",
        },
        {
          type: "Prerequisite Client",
          val: "3",
        },
        {
          type: "KYC Template",
          val: "4",
        },
      ],
      ExcelBtnName1: "New Export as Excel",
      ExcelBtnName: "Export as Excel",
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      FilterData: {
        CommonFilter: "",
        ClientType: "5",
        ClientTypeFilter:"",
      },
      modalInfo: { title: "", content: "" },
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      clientId: "",
      clientListView: [],
      excelUpload: "",
      showUploadModal: false,
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    ModelListSelect,
    // Loading,
    CustomLoader,
    SendEmail,
    SalesClientUpload,
  },
  created() {
    eventBus.$on("sendMailID", (sendMailID) => {
      console.log("sendMailID=>", sendMailID);
      if (sendMailID.mail_id > 0) {
        this.$refs["addPop"].open();
      } else {
        this.$refs["addPop"].open();
      }
      this.alert.content = sendMailID.MSG;
      this.viewClientDetail();
    });
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.clientId;

      this.itemObj.clientIsActive = this.itemObj.clientIsActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "clientdetail",
        tableId: "clientId",
        tableIsActive: "clientIsActive",
        value1: this.itemObj.clientIsActive,
        tableVal: this.deleteId,
        isMailSend: "No",
        manual: "No",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.viewClientDetail();
          }
        })
        .catch((error) => {});
    },
    updateClientType(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.is_lead =
        this.itemObj.is_lead == 1 ? 1 : this.itemObj.is_lead == 3 ? 3 : 2;
      let paylod = {
        tableName: "clientdetail",
        tableId: "clientId",
        tableIsActive: "is_lead",
        value1: this.itemObj.is_lead,
        tableVal: item.clientId,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.viewClientDetail();
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },
    Clearfilter() {
      this.FilterData = {
        CommonFilter: "",
        ClientType: "5",
        ClientTypeFilter:"",
      };
      this.viewClientDetail();
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewClientDetail();
      }, 1000);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    downloadZip(items) {
      NodeLockPannelService.downloadClientZip(items.clientId)
        .then((response) => {
            const { data, status } = response;

            if (status === 200 && data) {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${items.clientName}_${items.clientId}_docs.zip`); // Set a default file name
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url); // Clean up
            }
        })
        .catch((error) => {
            console.log("Catch on downloadZip Error: ", error);
        });
    },
    goToDrag(items) {
      this.$sessionsStorage.set("editClientId", "");
      this.$sessionsStorage.set("editClientName", "");
      this.$sessionsStorage.set("editClientExcelTemplate", "");
      this.$sessionsStorage.set("editClientId", items.clientId);
      this.$sessionsStorage.set("editClientName", items.clientName);
      this.$sessionsStorage.set("editClientExcelTemplate", items.excel_template_json);

      this.$router.push({
        path: "/drag_drop",
      });
    },
    goToMain() {
      this.$sessionsStorage.set("editClientId", "");
      this.$sessionsStorage.set("editClientType", "");

      this.$router.push({
        path: "/client/addClient",
      });
    },

    goToClientDashboard() {
      this.$router.push({
        path: "/dashboard/client-teus-dashboard",
      });
    },
    handleUploadSuccess() {
      // Refresh the client list after successful upload
      this.viewClientDetail();
      // Close modal after a short delay
      setTimeout(() => {
        this.showUploadModal = false;
      }, 1500);
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    JqueryFun() {
      return $(function () {
        return $("#viewSalesBooking").DataTable();
      });
    },

    onClose(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "clientdetail",
          tableIsActive: "clientIsActive",
          tableId: "clientId",
          tableVal: this.clientId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.viewClientDetail();

              // console.log(data);
            }
          })
          .catch((error) => {});
      } else {
        this.viewClientDetail();
      }
    },

    deleteClient(clientID) {
      this.clientId = clientID;
      this.$refs["addPop"].open();
    },

    viewClientpage(items) {
      console.log("CLient Dewtails=>", items);
      this.$sessionsStorage.set("editClientId", "");
      this.$sessionsStorage.set("editClientBranchId", "");
      this.$sessionsStorage.set("editClientId", items.clientId);
      this.$sessionsStorage.set("editClientBranchId", items.access_branch_ids);
      this.$router.push({
        path: "/client/addClient",
      });
    },

    viewClientDetail() {
      // this.doLoading();
      this.isLoading = true;
      let client_detail = {
        onlyClientview: "view",
        Filter: this.FilterData,
        Status:this.Status
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewClientList.php`,
        data: JSON.stringify(client_detail),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Priyanshu Singh=>", result);
          const { statusText, status, data } = result;
          if (data.clientId != "" && status == 200 && data) {
            // this.JqueryFun();

            this.clientListView = data.allclient1;
            this.totalRows = data.allclient1.length;
            // this.doLoadingClose();
            console.log(data);
          }
          this.isLoading = false;
        })
        .catch((error) => {});
    },
    downloadExcel() {
      let excelName = {
        excelName: "ClientMaster",
        validExcel: "yes",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch((error) => {});
    },

    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`clientMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.viewClientDetail();
        })
        .catch((err) => {
          throw err;
        });
    },
    getReportsAss(id, btnName) {
      let excelIdGivin = "";
      if (id == "All_CLIENT_Report") {
        excelIdGivin = "All_CLIENT_Report";
      }
      let view_CLIENT = {
        excelId: excelIdGivin,
        assignmentNo: "CLIENT",
        searchVal: this.filter,
      };

      this.ExcelBtnName = "Downloading Please Wait .....";

      CommonService.getAgentColoderExcel(view_CLIENT)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.excelName) {
              this.ExcelBtnName = btnName;
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              // `http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` + data.excelName;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },

    getReportsNew(id, btnName) {
      let excelIdGivin = "";
      if (id == "All_CLIENT_ReportNew") {
        excelIdGivin = "All_CLIENT_ReportNew";
      }
      let view_CLIENT = {
        excelId: excelIdGivin,
        assignmentNo: "CLIENT",
        searchVal: this.filter,
      };

      this.ExcelBtnName1 = "Downloading Please Wait .....";

      CommonService.getAgentColoderExcel(view_CLIENT)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.excelName) {
              this.ExcelBtnName1 = btnName;
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              // `http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` + data.excelName;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_CLIENT_ReportNew Error: ", error);
        });
    },

    // Added By Priyanshu Singh Start
    SelectAll: function () {
      console.log("this.User List=>", this.clientListView);
      this.isCheckAll = !this.isCheckAll;
      this.AllClientIds = [];
      this.AllEmailId = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.clientListView) {
          let single_data = "";
          this.AllClientIds.push(this.clientListView[key].clientId);
          this.AllEmailId.push(this.clientListView[key].email);
        }
        console.log("this.AllClientIds=>", this.AllClientIds);
        console.log("this.AllEmailId=>", this.AllEmailId);
      }
    },
    updateSelectAll: function (e, item) {
      console.log("ids", e);
      console.log("ids", item);
      if (this.AllClientIds.length == this.clientListView.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      const istrue = this.AllClientIds.includes(item.clientId);
      if (istrue == true) {
        this.AllEmailId.push(item.email);
      } else {
        const index = this.AllEmailId.indexOf(item.email);
        this.AllEmailId.splice(index, 1);
      }

      console.log("this.AllClientIds=>", this.AllClientIds);
      console.log("this.AllEmailId=>", this.AllEmailId);
    },
    //getReportsAss(id, btnName) {
    //  this.isLoading = true;
    //  let excelIdGivin = "";
    //  if (id == "All_CLIENT_Report") {
    //    excelIdGivin = "All_CLIENT_Report";
    //  }
    //  let view_CLIENT = {
    //    excelId: excelIdGivin,
    //    assignmentNo: "CLIENT",
    //    searchVal: this.filter,
    //  };
    // let options = {
    //    method: "POST",
    //    url: `${URL_BASE}/Api_Reports/reportsAgentColoderExcel.php`,
    //    data: JSON.stringify(view_CLIENT),
    //    crossDomain: true,

    //    headers: {
    //      Accept: "application/json",
    //      "Content-Type": "application/json",
    //      Authorization: this.$sessionsStorage.get("loginId"),
    //    },
    //  };

    //  axios(options)
    //    .then((result) => {
    //      const { statusText, status, data } = result;
    //      if (status == 200 && data) {
    //        if (data.excelName != undefined) {
    //          window.location.href =
    //            `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
    //        }
    //        this.isLoading = false;
    //      }
    //    })
    //    .catch((error) => {});
    //},
    // Added By Priyanshu Singh Start
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// viewClient.vue?1f77e5b9